import { WritableSignal } from '@angular/core';
import { MatSort } from '@angular/material/sort';

export function sortingColumns(
  sort: MatSort,
  currentPage: WritableSignal<number>,
  ordering: WritableSignal<string[]>,
  allowedColumns: Set<string>,
  updateListFn: () => void,
) {
  return sort.sortChange.subscribe(() => {
    if (!allowedColumns.has(sort.active)) return;

    currentPage.set(1);

    const sortColumn = sort.active;
    const sortKey = sort.direction === 'desc' ? `-${sortColumn}` : sortColumn;

    if (sort.direction) {
      ordering.set([sortKey]);
    } else {
      ordering.set([]);
    }

    updateListFn();
  });
}
